import { useEffect } from 'react';
import { useMediaQuery } from '@mantine/hooks';
import { useMe } from '@/queries/me/useMe';

// Matches the mobile breakpoint used elsewhere in the app (e.g. HomeViews, ClientAreaPage).
const MOBILE_MEDIA_QUERY = '(max-width: 768px)';

export const UiScaleEffect = () => {
  const { data: me } = useMe();
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
  const user = me?.user;
  const scale = (isMobile ? user?.uiScaleMobile : user?.uiScaleDesktop) ?? 100;

  useEffect(() => {
    document.documentElement.style.fontSize = `${scale}%`;

    return () => {
      document.documentElement.style.fontSize = '';
    };
  }, [scale]);

  return null;
};
